import { gql } from '@moonpig/web-core-graphql'

export const CreateDesignWithIntentsGQL = gql`
  mutation CreateDesignWithIntents($input: CreateDesignInput!) {
    createDesign(input: $input) {
      __typename
      ... on Design {
        id
      }
      ... on DesignTemplatesServiceError {
        message
      }
      ... on DesignServiceError {
        message
      }
      ... on Error {
        message
      }
    }
  }
`
